import { Component, h, Listen, Prop, State } from '@stencil/core';
import { StsType } from '../../../services/authentication/authentication.models';
import { Header } from '../../navigation-structure.models';
import { LogLevel } from '../../pnl-user-menu/utility/logging.service';

@Component({
    tag: 'pnl-desktop-navigation'
})
export class DesktopNavigation {
    @State() searchActive: boolean;

    @Prop() logLevel: LogLevel = LogLevel.warn;

    @Prop() domain: string;
    @Prop() locale: string;
    @Prop() availableLocales: string;

    @Prop() navigation: Header;

    @Prop() stsType: StsType;
    @Prop() stsServer: string;
    @Prop() clientId: string;
    @Prop() audience: string;
    @Prop() scope: string;
    @Prop() silentRenewPage: string;
    @Prop() silentRenewScript: string;
    @Prop() redirectUri: string = location.origin;
    @Prop() postLogoutRedirectUri: string = location.origin;
    @Prop() bpStsServer: string;
    @Prop() bpClientId: string;

    @Listen('searchActivated')
    searchActivated(event: CustomEvent) {
        this.searchActive = event.detail;
    }

    render() {
        return (
            <div class="pnl-header--desktop">
                <div class="pnl-header__utility">
                    <div class="pci-inner-container">
                        <pnl-language-selector availableLocales={this.availableLocales} locale={this.locale}></pnl-language-selector>
                    </div>
                </div>
                <div class="pnl-header__main pnl-header__main--desktop pnl-navigation">
                    <div class="pci-inner-container pnl-navigation-container">
                    <pnl-navigation-menu searchActive={this.searchActive} navigation={this.navigation} locale={this.locale}></pnl-navigation-menu>
                        <div class="pnl-menu-spacer"></div>
                        {(this.stsServer || this.bpStsServer) &&
                            <pnl-user-menu
                                class={'pnl-user-menu-container'}
                                hidden={this.searchActive}
                                log-level={this.logLevel}
                                language={this.locale}
                                domain={this.domain}
                                sts-type={this.stsType}
                                sts-server={this.stsServer}
                                client-id={this.clientId}
                                audience={this.audience}
                                scope={this.scope}
                                silentRenewPage={this.silentRenewPage}
                                silentRenewScript={this.silentRenewScript}
                                redirect-uri={this.redirectUri}
                                post-logout-redirect-uri={this.postLogoutRedirectUri}
                                bp-sts-server={this.bpStsServer}
                                bp-client-id={this.bpClientId}>
                            </pnl-user-menu>
                        }
                        <pnl-search class="pci-navigation__search" domain={this.domain} locale={this.locale}></pnl-search>
                    </div>
                </div>
            </div>
        );
    }
}
